var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMechanismIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 776.2 800",
    style: {
      enableBackground: "new 0 0 776.2 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671.4,400c0-8.3-1.7-16.1-2.4-24.2l107.2-103.6l-83.3-144.3c0,0-84.5,24.2-142.2,40.7 c-13.6-9.5-28.1-17.6-43.3-24.7L471.4,0H304.7c0,0-21.4,85.7-36,143.8c-15.2,7.1-29.7,15.1-43.3,24.7L83.3,127.8L0,272.2 c0,0,64.3,62.1,107.2,103.6c-0.7,8.1-2.4,15.9-2.4,24.2c0,8.3,1.7,16.1,2.4,24.2L0,527.8l83.3,144.3l142.2-40.7 c13.6,9.5,28.1,17.6,43.3,24.7l36,143.8h166.7l36-143.8c15.2-7.1,29.7-15.1,43.3-24.7l142.2,40.7l83.3-144.3L669,424.2 C669.7,416.1,671.4,408.3,671.4,400z M388.1,500c-55.2,0-100-44.8-100-100s44.8-100,100-100s100,44.8,100,100S443.3,500,388.1,500z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanismIcon);
export default __webpack_public_path__ + "static/media/mechanism_icon.864175dad3448cd7031761ab156d81b9.svg";
export { ForwardRef as ReactComponent };